import React from "react";
import { wrapperEditField, fieldActionContainerStyle } from "../step-4.css";
import { Text } from "@vagastec/ensemble-core";
import { Space } from "./space";
import { IconeEditAlt } from "../icons/icone-edit-alt";
import { IconeLockAlt } from "../icons/icone-lock-alt";
import { IconeCheckCircle } from "../icons/icone-check-circle";
import { Button } from "./button";
import { IconeLockOpen } from "../icons/icone-lock-open";
import { FieldLock } from "./field-lock";
import { btnEdit, btnEditVariants } from "./button.css";
import { vars } from "../theme.css";
import { FormattedMessage } from "react-intl";

export function EditLock({
  title,
  isEditing,
  setIsEditing,
  isLocked,
  setIsLocked,
  isVagaModelo,
  isLockNotAllowed,
  hidden,
  invalid,
  isFromVagaModelo,
  dataTestIdBtn,
  dataTestIdLock,
}) {
  return (
    <div className={wrapperEditField} data-testid="fieldLock">
      <Text
        size="rg"
        weight={600}
        as="h2"
        fontColor={invalid ? vars.color.errorForeground : null}
      >
        {title}
      </Text>
      <Space height=".5rem" />
      <div className={fieldActionContainerStyle}>
        {isVagaModelo && !hidden ? (
          <FieldLock
            checked={isLocked}
            onChange={() => setIsLocked(!isLocked)}
            disabled={isLockNotAllowed}
            data-testid={dataTestIdLock}
          >
            {isLocked ? (
              <>
                <Text size="xs">
                  <FormattedMessage
                    id="editLock.bloqueado"
                    defaultMessage="Bloqueado"
                  />
                </Text>{" "}
                <IconeLockAlt width={16} height={16} />
              </>
            ) : (
              <>
                <Text size="xs">
                  <FormattedMessage
                    id="editLock.desbloqueado"
                    defaultMessage="Desbloqueado"
                  />
                </Text>{" "}
                <IconeLockOpen width={16} height={16} />
              </>
            )}
          </FieldLock>
        ) : null}

        <Button
          className={`${btnEdit} ${
            btnEditVariants[isEditing ? "active" : "inactive"]
          }`}
          onClick={() => setIsEditing((prev) => !prev)}
          disabled={isFromVagaModelo && isLocked}
          data-testid={dataTestIdBtn}
        >
          <Text size="xs">
            <FormattedMessage id="editLock.editar" defaultMessage="Editar" />{" "}
          </Text>
          {!isEditing ? (
            <IconeEditAlt width={14} height={14} />
          ) : (
            <IconeCheckCircle width={14} height={14} />
          )}
        </Button>
      </div>
    </div>
  );
}
